import React from 'react';
import { Hero } from '../components/Hero';
import { WhyChooseUs } from '../components/WhyChooseUs';
import { Services } from '../components/Services';
import { WhyUs } from '../components/WhyUs';
import { FAQ } from '../components/FAQ';
import { Testimonials } from '../components/Testimonials';
import { Consultation } from '../components/Consultation';
import { CookieBanner } from '../components/CookieBanner';
import { Navigation } from '../components/Navigation';
import { Footer } from '../components/Footer';
import { CallbackWidget } from '../components/CallbackWidget';
export function LandingPage() {
  return <div className="min-h-screen w-full" style={{
    backgroundColor: 'var(--bg-primary)'
  }} data-id="element-429">
      <Navigation data-id="element-430" />

      <main data-id="element-431">
        <Hero data-id="element-432" />
        <WhyChooseUs data-id="element-433" />
        <WhyUs data-id="element-434" />
        <Services data-id="element-435" />
        <FAQ data-id="element-436" />
        <Testimonials data-id="element-437" />
        <Consultation data-id="element-438" />
      </main>

      <Footer data-id="element-439" />
      <CookieBanner data-id="element-440" />
      <CallbackWidget data-id="element-441" />
    </div>;
}